
<ng-container [ngSwitch]="column.template||column.name">

    <a *ngSwitchCase="'buildingid'" href="javascript:false;" (click)="showBuilding(record)">
        {{record[column.name]}}
    </a>

    <a *ngSwitchCase="'pointid'" href="javascript:false;" (click)="showPoint(record)">
        {{record[column.name]}}
    </a>

    <ng-container *ngSwitchCase="'sourcetable'">
        <a *ngIf="record['sourcetable']=='location_tmo_0'; else noLocationImpl" href="javascript:false;" (click)="showParticipantLocation(record)">
            {{record[column.name]}}
        </a>
        <ng-template #noLocationImpl>
            {{record[column.name]}}
        </ng-template>
    </ng-container>

    <a *ngSwitchCase="'callsourceid'" href="javascript:false;" (click)="showCall(record)" class="text-nowrap">
        {{record[column.name]}}
    </a>

    <a *ngSwitchCase="'callstarttime'" href="javascript:false;" (click)="showCall(record)" class="text-nowrap">
        {{record[column.name]|date:'yyyy-MM-dd HH:mm:ss.SSS':'UTC'}}
    </a>

    <a *ngSwitchCase="'locationtime'" href="javascript:false;" (click)="showLocation(record)" class="text-nowrap">
        {{record[column.name]|date:'yyyy-MM-dd HH:mm:ss.SSS':'UTC'}}
    </a>

    <span *ngSwitchCase="'time'" class="text-nowrap">
        {{record[column.name]|date:'yyyy-MM-dd HH:mm:ss.SSS':'UTC'}}
    </span>

    <div *ngSwitchCase="'boolean'" [attr.title]="record[column.name]" class="text-center">
        <i class="fa" [ngClass]="{'fa-check text-success':record[column.name]===true,'fa-times text-danger':record[column.name]===false}"></i>
    </div>

    <div *ngSwitchCase="'avgbarometricpressure'" class="text-center">
        {{record[column.name]|number:'1.6-6'}}
    </div>

    <ng-container *ngSwitchCase="'editUser'">
        <a *ngIf="record[column.name]" href="javascript:false;" (click)="editUser($any(record))" class="text-nowrap">
            {{record[column.name]}}
        </a>
    </ng-container>

    <ng-container *ngSwitchCase="'taskid'">
        <a *ngIf="record[column.name] else noTaskId" href="javascript:false;" (click)="showTask($any(record))" class="text-nowrap">
            {{record[column.name]}}
        </a>
        <ng-template #noTaskId>
        <div class="text-center">
        <a *ngIf="record.calltesttype=='dialer'" href="javascript:false;" (click)="showTask($any(record))"
        class="text-center">
            <i class="fa fa-list"></i>
        </a>
    </div>
        </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="'testpointid'">
        <a *ngIf="record[column.name]" href="javascript:false;" (click)="showTestPoint($any(record))" class="text-nowrap">
            {{record[column.name]}}
        </a>
    </ng-container>

    <ng-container *ngSwitchDefault>
        {{record[column.name]}}
    </ng-container>

</ng-container>

